import { axiosInstance } from '../lib/api_client'

const PATH = '/stripe_checkout_sessions'

type CreateParams = Readonly<{
  addressId?: number
  regionShippingServiceId?: number
  returnPath: string
  referral: string
  points: number
  mode: 'subscription' | 'payment'
}>

type CreateResponse = Readonly<{
  sessionId: string
  clientSecret: string
}>

type StripeCheckoutSessionsRepository = Readonly<{
  create: (params: CreateParams) => Promise<CreateResponse>
}>

const stripeCheckoutSessionsRepository: StripeCheckoutSessionsRepository = {
  async create (params) {
    return await axiosInstance.post(PATH, { stripeCheckoutSession: params }).then(({ data }) => data)
  },
}

export { stripeCheckoutSessionsRepository }
